import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import TagsFilters from "../TagsFilters/TagsFilters";
import ChiffresClesStatistiquesUsage from "../Base/ChiffresClesStatistiquesUsage/ChiffresClesStatistiquesUsage";
import ChartsStatistiquesUsages from "../Base/ChartsStatistiquesUsages/ChartsStatistiquesUsages";

//  partie bien être ressentis
import Tables from "../Base/Tables/Tables";
import ChiffresClesBienEtreRessenti from "../Base/ChiffresClesBienEtreRessenti/ChiffresClesBienEtreRessenti";
import ChartsBienEtreRessenti from "../Base/ChartsBienEtreRessenti/ChartsBienEtreRessenti";



class StatistiquesUsages extends Component {
  constructor() {
    super();
    this.state = {
      error: false,
      newFetch: false
    };
  }

    getTagsRequest() {
        let res = "";
        if (window.selectedTags) {
          window.selectedTags.forEach(tag => {
            res.length
              ? (res = res + "&tags[]=" + tag)
              : (res = res + "?tags[]=" + tag);
          });
        }

        //  si on a bien les dates de selectionnées, on les ajoute à la requete
        if (window.startDateMysql) {
            (res != "")
              ? (res = res + "&startDate=" + window.startDateMysql)
              : (res = res + "?startDate=" + window.startDateMysql);
        }

        //  si on a bien les dates de selectionnées, on les ajoute à la requete
        if(window.endDateMysql) {
            (res != "")
              ? (res = res + "&endDate=" + window.endDateMysql)
              : (res = res + "?endDate=" + window.endDateMysql);
        }
        console.log('requete détaillé'  + res);
        return res;
    }

  updateData() {
    try {
      this.setState({newFetch: !this.state.newFetch});
    } catch (e) {
      console.log(e);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.error) {
      this.setState({ error: false });
    }
  }

  notifyError() {
    toast.error(
      "2) Les tags sélectionnés sont trop précis, merci de sélectionner moins de tags."
    );
    this.setState({ error: true });
  }

  render() {
    return (
      <div className="animated fadeIn">
        <ToastContainer/>
        <br/>
        <TagsFilters
          error={this.state.error}
          updateData={this.updateData.bind(this)}
        />

        <h3>Statistiques d'usage</h3>
        <ChiffresClesStatistiquesUsage
          request={this.getTagsRequest()}
          isAdmin={false}
          notifyError={this.notifyError.bind(this)}
          error={this.state.error}
          newFetch={this.state.newFetch}
        />
        <ChartsStatistiquesUsages
          request={this.getTagsRequest()}
          isAdmin={false}
          notifyError={this.notifyError.bind(this)}
          error={this.state.error}
          newFetch={this.state.newFetch}
        />


        <h3>Bien-être ressenti</h3>
        <ChiffresClesBienEtreRessenti
          request={this.getTagsRequest()}
          isAdmin={false}
          notifyError={this.notifyError.bind(this)}
          error={this.state.error}
          newFetch={this.state.newFetch}
        />
        <Row>
          <Col>
            <Tables
              newFetch={this.state.newFetch}
              tableType="resultsByUniverses"
              perPage={3}
            />
          </Col>
        </Row>
        <ChartsBienEtreRessenti
          request={this.getTagsRequest()}
          isAdmin={false}
          notifyError={this.notifyError.bind(this)}
          error={this.state.error}
          newFetch={this.state.newFetch}
        />
        <Row>
          <Col>
            <Tables
              newFetch={this.state.newFetch}
              tableType="resultsByThematics"
              perPage={12}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Tables
              newFetch={this.state.newFetch}
              tableType="resultsByQuestions"
              perPage={20}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default StatistiquesUsages;



// WEBPACK FOOTER //
// ./src/views/StatistiquesUsages/StatistiquesUsages.js